/* eslint-disable react/prop-types */
import { memo, useEffect, useState } from 'react';

import { useSelector } from 'react-redux';
import MediaQuery from 'react-responsive';

import { device } from 'helpers/screenSizes';
import { socketActiveSelector } from 'selectors/socketSelectors';

import DesktopView from './DesktopView';
import MobileView from './MobileView';

// TODO: Add prop types
const ConnectionStatusStrip = ({
  isInternetConnected,
  offlineTime,
  socketDisconnectTime,
  isloggedin,
}) => {
  const socketActive = useSelector(state => socketActiveSelector(state));
  const [updateCounter, setUpdateCounter] = useState(0);
  const isOnline = isInternetConnected && socketActive !== false;
  const isOffline = !isOnline;

  useEffect(() => {
    let timer;
    if (isOffline) {
      timer = setTimeout(() => {
        setUpdateCounter(prev => prev + 1);
      }, 10 * 1000);
    }
    return () => {
      clearTimeout(timer);
    };
  }, [updateCounter, isOffline]);

  // we need to find which thing happened first, offline or socket disconnect
  const earlierDisconnect =
    offlineTime && socketDisconnectTime
      ? Math.min(offlineTime, socketDisconnectTime)
      : offlineTime || socketDisconnectTime;

  return (
    <>
      <MediaQuery query={device.up.md}>
        <DesktopView
          isloggedin={isloggedin}
          isOnline={isOnline}
          isOffline={isOffline}
          disconnectTime={earlierDisconnect}
          updateCounter={updateCounter}
        />
      </MediaQuery>
      <MediaQuery query={device.down.md}>
        <MobileView
          disconnectTime={earlierDisconnect}
          isOnline={isOnline}
          updateCounter={updateCounter}
        />
      </MediaQuery>
    </>
  );
};

export default memo(ConnectionStatusStrip);
